import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { UserModel } from './user.model';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class UserResolver {
  constructor(private service: UserService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<UserModel> {
    return this.service.getById(route.paramMap.get('id') || '').pipe(map((user) => user.data));
  }
}
